import React from 'react'
import { connect } from 'react-redux'
import { defineMessages, FormattedMessage } from 'react-intl'
import { selectEmergencyReserveTarget } from 'src/store/selectors/home/equity'
import { Heading, ProConList, Pro, Info } from 'src/Components/Gem/GemDetail'

const EmergencyReserve = props => (
  <div>
    <Heading>
      <FormattedMessage
        id='Homeowner.equity.emergenciesHeading'
        defaultMessage="Emergencies are a part of life—car troubles, job loss or even a broken leg! Having access to six months' worth of living expenses can reduce stress and prepare you for surprises."
      />
    </Heading>

    <ProConList>
      <Pro>
        <FormattedMessage
          id='Homeowner.equity.emergenciesOne'
          defaultMessage='An established HELOC gives you easy access to funds and frees your cash for other investments'
        />
      </Pro>
      <Pro>
        <FormattedMessage
          id='Homeowner.equity.emergenciesTwo'
          defaultMessage='Make sure to stay disciplined and only use the money for true emergencies'
        />
      </Pro>
      <Info>
        <FormattedMessage
          id='Homeowner.equity.emergenciesThree'
          defaultMessage='You should consider paying off any high-interest debt first'
        />
      </Info>
    </ProConList>
  </div>
)

export default {
  GemContainer: connect(state => ({
    qaTag: 'emergencyReserveGem',
    amount: selectEmergencyReserveTarget(state)
  })),
  Detail: EmergencyReserve,
  ...defineMessages({
    question: {
      id: 'Homeowner.equity.emergenciesQuestion',
      defaultMessage: 'How do I get a HELOC?'
    },
    topic: {
      id: 'Homeowner.equity.emergenciesTopic',
      defaultMessage: 'creating an emergency fund'
    }
  })
}
